import { render, staticRenderFns } from "./MentionsContent.vue?vue&type=template&id=d9f51abc"
import script from "./MentionsContent.vue?vue&type=script&lang=js"
export * from "./MentionsContent.vue?vue&type=script&lang=js"
import style0 from "./MentionsContent.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports